var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleandgreychek({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 0.575012H3.45001C1.86219 0.575012 0.575012 1.86219 0.575012 3.45001V19.55C0.575012 21.1378 1.86219 22.425 3.45001 22.425H19.55C21.1378 22.425 22.425 21.1378 22.425 19.55V3.45001C22.425 1.86219 21.1378 0.575012 19.55 0.575012Z",
    stroke: "#C8C8CB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9167 10.9583C19.9167 6.01078 15.9059 2 10.9583 2C6.01078 2 2 6.01078 2 10.9583C2 15.9059 6.01078 19.9167 10.9583 19.9167C15.9059 19.9167 19.9167 15.9059 19.9167 10.9583Z",
    fill: "#005857",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7143 7.03573C16.0397 7.36117 16.0397 7.88881 15.7143 8.21425L9.30401 14.6245C8.97857 14.9499 8.45094 14.9499 8.1255 14.6245L6.20242 12.7014C5.87699 12.376 5.87699 11.8483 6.20242 11.5229C6.52786 11.1975 7.05549 11.1975 7.38094 11.5229L8.71475 12.8567L14.5358 7.03573C14.8612 6.7103 15.3888 6.7103 15.7143 7.03573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleandgreychek);
export default __webpack_public_path__ + "static/media/Rectangleandgreychek.e91b7982.svg";
export { ForwardRef as ReactComponent };